export * from './address.service';
import { AddressService } from './address.service';
export * from './group.service';
import { GroupService } from './group.service';
export * from './keyCloak.service';
import { KeyCloakService } from './keyCloak.service';
export * from './masterData.service';
import { MasterDataService } from './masterData.service';
export const APIS = [AddressService, GroupService, KeyCloakService, MasterDataService];
